import React, { Component } from 'react';
import { Grid, Typography, withStyles } from '@material-ui/core';
import { DateFormatInput } from 'material-ui-next-pickers';

const styles = (theme) => ({
    textField: {
        paddingRight: 30,
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            paddingBottom: 30,
        },
        marginBottom: 15,
    },
    cssRoot: {
        position: 'initial',
        lineHeight: theme.typography.pxToRem(8),
        height: 30,
    },
});

class TableFilterDate extends Component {
    constructor(props) {
        super(props);
        const { filter, activeFilters } = this.props;

        this.state = {
            value: {
                gte: activeFilters[filter.fieldName] ? activeFilters[filter.fieldName].gte : new Date(),
                lte: activeFilters[filter.fieldName] ? activeFilters[filter.fieldName].lte : new Date(),
            },
        };
    }

    handleDateChange = (type) => (val) => {
        const { filter, onChange } = this.props;
        const { value } = this.state;

        this.setState({ value: { ...value, [type]: val } }, () =>
            onChange('date', filter.fieldName, value)
        );
    };

    render() {
        const { filter, intl, classes } = this.props;
        const {
            value: { gte, lte },
        } = this.state;
        return (
            <Grid container>
                <Grid item xs={12}>
                    <Typography>{intl.formatMessage({ id: 'Time.from' })}</Typography>
                    <DateFormatInput
                        label={filter.labe}
                        name={`${filter.fieldName}-from`}
                        value={gte}
                        onChange={this.handleDateChange('gte')}
                        className={classes.textField}
                        InputProps={{
                            classes: {
                                root: classes.cssRoot,
                            },
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography>{intl.formatMessage({ id: 'Time.to' })}</Typography>
                    <DateFormatInput
                        label={filter.labe}
                        name={`${filter.fieldName}-to`}
                        value={lte}
                        onChange={this.handleDateChange('lte')}
                        className={classes.textField}
                        InputProps={{
                            classes: {
                                root: classes.cssRoot,
                            },
                        }}
                    />
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(TableFilterDate);
